<template>
    <div class="user-details">
        <input type="file" ref="file" style="display: none">
        <img class="profile-image preload-image" :src="user.profileImg" alt="img" @click="$refs.file.click()">
        <div class="profile-body">
            <h1 class="profile-heading">{{ user.fullName }}</h1>
            <h2 class="profile-sub-heading"><a href="#" class="color-highlight">{{ user.role }}</a></h2>
            <h2 class="profile-sub-heading">{{ user.email }}</h2>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserDetails',
    data(){
        return{
            user: null
        }   
    },
    created(){
        this.user = JSON.parse(localStorage.getItem('user'));
    }
}
</script>

<style>
.profile-2 .profile-image {
    width: 170px;
    border-radius: 170px;
    margin: 20px auto 30px auto;
    border: solid 5px #FFF;
    box-shadow: 0px 2px 15px rgba(0,0,0,0.20);
}
.profile-2 .profile-heading {
    text-align: center;
    font-size: 34px;
    font-weight: 700;
}
.profile-2 .profile-sub-heading {
    text-align: center;
    font-size: 13px;
    color: #666666;
    font-weight: 400;
    margin-top: -5px;
    letter-spacing: 1.1px;
}
.color-highlight {
    color: #4A89DC!important;
}
</style>